// extracted by mini-css-extract-plugin
export default {"profileBody":"profileBody_profileBody__pKIz9","tab_content":"profileBody_tab_content__WkIKi"};